import ApplePay from 'assets/icons/base/apple-pay-icon.svg';
import CardIcon from 'assets/icons/base/card-icon.svg';
import GPayIcon from 'assets/icons/base/gpay-icon.png';
import Plus24Icon from 'assets/icons/base/plus24-icon.svg';
import SimIcon from 'assets/icons/base/sim-icon.svg';
import TerminalIcon from 'assets/icons/base/terminal-icon.svg';
import { PAY_METHOD, PAY_TYPE } from 'constants/payment';

const acquiringIconType = (paymentType: number, formType: number) => {
  if (paymentType === PAY_TYPE.PAYMENT) {
    switch (formType) {
      case PAY_METHOD.PLUS24_2:
        return Plus24Icon;
      case PAY_METHOD.TERMINAL:
        return TerminalIcon;
      case PAY_METHOD.QIWI:
      case PAY_METHOD.MOBILE:
        return SimIcon;
      case PAY_METHOD.APPLE_PAY:
        return ApplePay;
      case PAY_METHOD.GOOGLE_PAY:
        return GPayIcon;
      case PAY_METHOD.BANK_CARD_1:
      case PAY_METHOD.BANK_CARD_9:
      default:
        return CardIcon;
    }
  }

  if (paymentType === PAY_TYPE.PAYOUT) {
    switch (formType) {
      case PAY_METHOD.MOBILE:
        return SimIcon;
      case PAY_METHOD.PLUS24_7:
        return Plus24Icon;
      case PAY_METHOD.APPLE_PAY:
        return ApplePay;
      case PAY_METHOD.GOOGLE_PAY:
        return GPayIcon;
      case PAY_METHOD.BANK_CARD_3:
      default:
        return CardIcon;
    }
  }

  return '';
};

export { acquiringIconType };
